import React, { useState, useContext } from "react";
import { useIntl } from "react-intl";
import RoomContext from "../../../context/RoomContext";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ActionsIcon from "@material-ui/icons/MoreHoriz";
import MicIcon from "@material-ui/icons/MicNone";
import VideoIcon from "@material-ui/icons/VideocamOutlined";

const MoreActionsMenu = () => {
  const { roomClient } = useContext(RoomContext);
  const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState(null);
  const intl = useIntl();
  const handleActionMenuClick = (event) => {
    setActionMenuAnchorEl(event.currentTarget);
  };

  const handleActionMenuClose = () => {
    setActionMenuAnchorEl(null);
  };
  return (
    <React.Fragment>
      <Tooltip
        placement="top"
        title={intl.formatMessage({
          id: "tooltip.moreActions",
          defaultMessage: "More",
        })}
      >
        <IconButton onClick={handleActionMenuClick} size="small">
          <ActionsIcon style={{ color: "#181c1e", width: 32, height: 32 }} />
        </IconButton>
      </Tooltip>
      <Menu
        id="action-menu"
        anchorEl={actionMenuAnchorEl}
        keepMounted
        open={Boolean(actionMenuAnchorEl)}
        onClose={handleActionMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          style: {
            borderRadius: "32px 0px 32px 32px",
          },
        }}
      >
        <MenuItem
          onClick={() => {
            handleActionMenuClose();
            roomClient.muteAllPeers();
          }}
        >
          <ListItemIcon>
            <MicIcon />
          </ListItemIcon>
          <ListItemText
            primary={intl.formatMessage({
              id: "room.muteAll",
              defaultMessage: "Mute All",
            })}
          />
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleActionMenuClose();
            roomClient.stopAllPeerVideo();
          }}
        >
          <ListItemIcon>
            <VideoIcon />
          </ListItemIcon>
          <ListItemText
            primary={intl.formatMessage({
              id: "room.stopAllVideo",
              defaultMessage: "Stop Video for All",
            })}
          />
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
};

export default MoreActionsMenu;
